import { render, staticRenderFns } from "./awardEditor.vue?vue&type=template&id=3cb9c007&"
import script from "./awardEditor.vue?vue&type=script&lang=js&"
export * from "./awardEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb9c007')) {
      api.createRecord('3cb9c007', component.options)
    } else {
      api.reload('3cb9c007', component.options)
    }
    module.hot.accept("./awardEditor.vue?vue&type=template&id=3cb9c007&", function () {
      api.rerender('3cb9c007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/components/awardEditor.vue"
export default component.exports